export const CAMPAIGN_PERMISSIONS = {
  FALSE: 'false',
  NOT_SUPPORTED_PLAN: 'not_supported_plan',
};
